import { combineReducers, createStore } from "redux";
import { LogoReducer , TickerReducer,ProductReducer,CategoriesReducer} from "./Reducer"
const rootReducer = combineReducers({LogoReducer,TickerReducer,ProductReducer,CategoriesReducer})
const store=createStore(rootReducer)
export default store;